export function schema_correspondance(columns) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			colonnes_id: {
				title: "Colonnes des correspondances",
				type: "array",
				format: "select",
				uniqueItems: true,
				items: {
					type: "string",
					enum: columns,
				},
			},
			colonnes: {
				title: "Colonnes à rajouter",
				type: "array",
				format: "select",
				uniqueItems: true,
				items: {
					type: "string",
					enum: columns,
				},
			},
			colonnes_opt: {
				title: "Colonnes optionelles",
				type: "array",
				format: "table",
				items: {
					type: "object",
					title: "colonne",
					properties: {
						actif: {
							title: "Actif",
							type: "boolean",
							format: "checkbox",
						},
						colonne: {
							title: "Colonne",
							type: "string",
							options: {
								inputAttributes: {
									class: "form-control dropdown-colonne",
								},
							},
						},
						poids: {
							title: "Poids",
							type: "number",
						},
					},
				},
			},
		},
	};
}
